import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EventGridControls } from 'types/currentEvent';

// initial state
const initialState: EventGridControls = {
  eventGridRange: [new Date(new Date().setHours(0, 0, 0, 0)), null],
  eventHistoriesCategory: 'event',
  searchValues: {},
  eventsScrollPosition: 0,
  salesContactsFilterModel: { items: [] },
  allVenuesFilterModel: { items: [] },
  // Pagination models for each grid
  contactsPaginationModel: { page: 0, pageSize: 50 },
  eventsPaginationModel: { page: 0, pageSize: 250 },
  venuesPaginationModel: { page: 0, pageSize: 50 },
  // Contacts tag filter
  contactsTagFilter: null,
  taskGridPastDueCutoff: '4d'
};

// ==============================|| SLICE - MENU ||============================== //

const reportControls = createSlice({
  name: 'reportControls',
  initialState,
  reducers: {
    setEventGridRange(state, action) {
      state.eventGridRange = action.payload.eventGridRange;
    },
    setEventHistoriesCategory(state, action) {
      state.eventHistoriesCategory = action.payload;
    },
    setSearchValue(state, action: PayloadAction<{ key: string; value: string }>) {
      const { key, value } = action.payload || {};
      if (!key) {
        return;
      }
      state.searchValues[key] = value ?? '';
    },
    setEventsScrollPosition(state, action) {
      state.eventsScrollPosition = action.payload;
    },
    setSalesContactsFilterModel(state, action) {
      state.salesContactsFilterModel = action.payload;
    },
    setAccountManagerFilter(state, action) {
      // Update filter model with account manager filter
      const existingItems = state.salesContactsFilterModel?.items || [];
      
      // Remove any existing account manager filter
      const filteredItems = existingItems.filter(
        item => item.field !== 'contact.accountManager'
      );
      
      // Add new account manager filter if value is provided
      if (action.payload) {
        filteredItems.push({
          field: 'contact.accountManager',
          operator: 'equals',
          value: action.payload
        });
      }
      
      state.salesContactsFilterModel = {
        ...state.salesContactsFilterModel,
        items: filteredItems
      };
    },
    setAllVenuesFilterModel(state, action) {
      state.allVenuesFilterModel = action.payload;
    },
    setCompanyTypeFilter(state, action) {
      // Update filter model with company type filter
      const existingItems = state.allVenuesFilterModel?.items || [];
      
      // Remove any existing company type filter
      const filteredItems = existingItems.filter(
        item => item.field !== 'companyType'
      );
      
      // Add new company type filter if value is provided
      if (action.payload) {
        filteredItems.push({
          field: 'companyType',
          operator: 'equals',
          value: action.payload
        });
      }
      
      state.allVenuesFilterModel = {
        ...state.allVenuesFilterModel,
        items: filteredItems
      };
    },
    setContactsPaginationModel(state, action) {
      state.contactsPaginationModel = action.payload;
    },
    setEventsPaginationModel(state, action) {
      state.eventsPaginationModel = action.payload;
    },
    setVenuesPaginationModel(state, action) {
      state.venuesPaginationModel = action.payload;
    },
    setContactsTagFilter(state, action) {
      state.contactsTagFilter = action.payload;
    },
    setTaskGridPastDueCutoff(state, action) {
      state.taskGridPastDueCutoff = action.payload;
    }
  }
});

export default reportControls.reducer;

export const {
  setEventGridRange,
  setEventHistoriesCategory,
  setSearchValue,
  setEventsScrollPosition,
  setSalesContactsFilterModel,
  setAccountManagerFilter,
  setAllVenuesFilterModel,
  setCompanyTypeFilter,
  setContactsPaginationModel,
  setEventsPaginationModel,
  setVenuesPaginationModel,
  setContactsTagFilter,
  setTaskGridPastDueCutoff
} = reportControls.actions;
